import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { Card, Button, Checkbox, Form, Modal, Upload, Icon, Input, Select, Spin, message } from "antd";
import _ from "lodash";
import Services from "../../../services/blog";
import CKEditor from 'ckeditor4-react';
const BlogForm = (props) => {
  const history = useHistory();

  const { TextArea } = Input;
  const Option = Select.Option;
  const FormItem = Form.Item;

  let PreviewFromLink = {
    uid: "",
    name: "",
    status: "done",
    response: "ok",
    url: "",
  };

  const [slug, setSlug] = useState("");
  const [blogTitle, setBlogTitle] = useState("");
  const [blogStatus, setBlogStatus] = useState(true);


  const [title, setTitle] = useState("");
  const [keywords, setKeywords] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  const [content, setContent] = useState("");
  const [isFeatured, setIsFeatured] = useState("");

  const [previewImage, setPreviewImage] = useState(null);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [image, setImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [isSave, setIsSave] = useState(false);
  const [alt, setAlt] = useState('') ;
  const [caption, setCaption] = useState('');
  useEffect(() => {

    getInitialData();
  }, []);

  const getInitialData = async () => {
    const { match } = props;

    let { id } = match.params;

    if (id) {
      const details = await Services.getBlogDetails(id);


      setSlug(details?.data?.slug);
      setBlogTitle(details?.data?.title);
      setBlogStatus(details?.data?.isActive);
      setTitle(details?.data?.metaTitle);
      setKeywords(details?.data?.metaKeywords);
      setMetaDescription(details?.data?.metaDescription);
      setShortDescription(details?.data?.shortDescription);
      setContent(details?.data?.content);
      setIsFeatured(details?.data?.isFeatured);
      setImage(details?.data?.image);
      setAlt(details?.data?.alt);
      setCaption(details?.data?.caption)
      setFileList(details?.data?.image
        ? [
          {
            ...PreviewFromLink,
            uid: details?.data?.image,
            name: "",
            url: `/api/util/image?key=${details?.data?.image}`,
          },
        ]
        : []);
      setIsEdit(true);
      setEditData(details?.data || {});
      setIsSave(details?.data?.slug ? true : false);
    }

  }

  const onChange = (evt) => {
    const newContent = evt.editor.getData();
    setContent(newContent);
  }

  const handleBlogTitle = (e) => {
    let slug = e.target.value.replace(/[^A-Za-z0-9-]/gi, "-").toLowerCase();

    setBlogTitle(e.target.value);
  };

  const handleSlug = (e) => {
    let slug = e.target.value.replace(/[^A-Za-z0-9-]/gi, "").toLowerCase();

    setSlug(slug);
  };

  const handleShortDescription = (e) => {
    setShortDescription(e.target.value);
  };

  const handleKeywords = (e) => {
    setKeywords(e.target.value);
  };

  const handleTitle = (e) => {
    setTitle(e.target.value);
  };

  const handleMetaDescription = (e) => {
    setMetaDescription(e.target.value);
  };

  const handleBlogStatus = (val) => {
    setBlogStatus(val);
  };


  const onCheckFeatured = (e) => {
    setIsFeatured(e.target.checked);
  };

  const handlePreview = (file) => {
    setPreviewImage(file.url || file.thumbUrl);
    setPreviewVisible(true);
  };

  const handleCancel = () => setPreviewVisible(false);

  const handleRemove = () => {
    setImage([]);
  };

  const customRequest = async ({ file, onSuccess }) => {
    setImage(file);
    setTimeout(() => onSuccess("ok"), 0);
  };

  const handleChange = ({ file, fileList }) => {
    setFileList(fileList)
  };

  const onPreview = () => {
    const url = `http://cmsplatform-web.herokuapp.com/${slug}`
    isSave && window.open(url, '_blank');
  }

  const handleAlt = (e) =>{
    setAlt(e.target.value)
  }

  const handleCaption = (e) =>{
    setCaption(e.target.value)
  }

  const onSubmit = async () => {
    if (slug && slug.length <= 2) {
      message.warning("Slug must be more than 2 characters");
      return;
    }
    if (
      !slug ||
      !title ||
      !keywords ||
      !metaDescription ||
      !content ||
      !blogTitle ||
      !alt ||
      !caption
    ) {
      message.error("Please insert all required fields");
      return;
    }

    setLoading(true);
  

    let thumbIMG;
    if (image) {
      thumbIMG = await Services.uploadToS3({ file: image });
      Promise.resolve(thumbIMG);
      console.log(thumbIMG);
    }

    const { match } = props;

    let { id } = match.params;

    if (isEdit && !id) {
      message.error("Blog id is missing");
      return;
    }

    let blogResponse;
    try {
      if (!isEdit) {
        blogResponse = await Services.addBlog({
          slug,
          blogStatus,
          title,
          keywords,
          description: metaDescription,
          shortDescription,
          content,
          blogTitle,
          isFeatured,
          image: thumbIMG?.fileName,
          alt,
        caption
        });
        console.log(blogResponse);
      } else {

        blogResponse = await Services.editBlog({
          blogId: id,
          slug,
          blogStatus,
          title,
          keywords,
          description: metaDescription,
          shortDescription,
          content,
          blogTitle,
          isFeatured,
          image: thumbIMG?.fileName,
          alt,
          caption
        });
      }
    } catch (e) {
      message.error(e.response.data.error);
    }

    if (blogResponse?.status == 200) {
      setLoading(false);
      message.success("Saved!");
      setIsSave(true);
      history.push("/blogs")
    } else {
      setLoading(false);
    }
  };

  const stateSetter = (stateName, stateValue) => {
    this.setState({
      [stateName]: stateValue,
    });
  };


  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  };

  const children = [];
  for (let i = 1; i < 10; i++) {
    children.push(<Option key={i.toString(36) + i}>{"test"}</Option>);
  }

  // MULTIPLE-scripts End
  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text">Upload</div>
    </div>
  );

  return (
    <Spin spinning={loading} size="large">
      <div className="menu-editor-box card-pad-new menu-cate-list users-main-page categoryForm-main">
        <div className="payout-report-box">
          <Card className="gx-card breadcrumb-box" title="">
            <div className="ant-row hd-title">
              <div className="ant-col-md-12">
                <h1>Manage Blog</h1>
              </div>
              <div className="ant-col-md-12 rite-btn d-none">
                <Button type="primary" className="color-white">
                  {" "}
                    Create
                  </Button>
              </div>
              <div className="ant-col-md-12">
                <div className="orders-item top-section filter-box ">
                  <div className="drop-filter-cover">
                    <Select
                      className="select-box"
                      defaultValue={"Select"}
                      value={blogStatus}
                      onChange={handleBlogStatus}
                    >
                      <Option value={true}> Enabled</Option>
                      <Option value={false}>Disabled</Option>
                    </Select>
                  </div>
                </div>
              </div>
            </div>
            <div className="ant-row gx-mt-4">
              <div className="ant-col-md-24">
                <div className="item-detail-edit-box">
                  <div className="ant-row">
                    <div className="ant-col-md-12">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label={<span><span style={{ color: "red" }}>*</span>Blog Title</span>}
                      >
                        <Input
                          type="text"
                          placeholder="Blog Title"
                          value={blogTitle}
                          onChange={handleBlogTitle}
                        />
                      </FormItem>
                    </div>

                  </div>
                  <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-8">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label={<span><span style={{ color: "red" }}>*</span>Slug/URL</span>}

                      >
                        <Input
                          type="text"
                          placeholder="Slug/URL"
                          onChange={handleSlug}
                          value={slug}
                        />
                      </FormItem>
                    </div>

                    <div className="ant-col-md-8">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label={<span><span style={{ color: "red" }}>*</span>Meta Keywords</span>}
                      >
                        <Input
                          type="text"
                          placeholder="Meta Keywords"
                          onChange={handleKeywords}
                          value={keywords}
                        />
                      </FormItem>
                    </div>

                    <div className="ant-col-md-8">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label={<span><span style={{ color: "red" }}>*</span>Meta Title</span>}
                      >
                        <Input
                          type="text"
                          placeholder="Meta Title"
                          onChange={handleTitle}
                          value={title}
                        />
                      </FormItem>
                    </div>
                  </div>
                  <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-16">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label={<span><span style={{ color: "red" }}>*</span>Meta Description</span>}
                      >
                        <TextArea
                          rows={3}
                          placeholder="Meta Description"
                          onChange={handleMetaDescription}
                          value={metaDescription}
                        />
                      </FormItem>
                    </div>

                    <div className="ant-col-md-8">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label={<span><span style={{ color: "red" }}></span>Short Description</span>}
                      >
                        <Input
                          type="text"
                          placeholder="Short Description"
                          value={shortDescription}
                          onChange={handleShortDescription}
                        />
                      </FormItem>
                    </div>

                    <div className="ant-col-md-8">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label="Action"
                      >
                        <Checkbox
                          checked={isFeatured}
                          onChange={onCheckFeatured}
                        >
                          Featured
                        </Checkbox>
                      </FormItem>
                    </div>
                  </div>

                  <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-24">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label={<span><span style={{ color: "red" }}>*</span>Content</span>}
                      >
                        <CKEditor
                          activeClass="p10"
                          data={content}
                          config={{
          //                   removePlugins: 'image',
					cloudServices_uploadUrl: 'https://33333.cke-cs.com/easyimage/upload/',
					cloudServices_tokenUrl:
						'https://33333.cke-cs.com/token/dev/ijrDsqFix838Gh3wGO3F77FSW94BwcLXprJ4APSp3XQ26xsUHTi0jcb1hoBt',
                            // filebrowserBrowseUrl: '/browser/browse.php',
                            //allowedContent: 'p b i s li ul ol h1 h2 bulletedList numberedlist',
                            // filebrowserUploadMethod: 'form',
                            extraPlugins: 'colorbutton,justify',
                            // // filebrowserUploadUrl :'/api/util/uploadimage', 
                            // cloudservices_uploadUrl:'https://33333.cke-cs.com/easyimage/upload/',
                            removeButtons:
                              "Subscript,Superscript,Underline,Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Find,SelectAll,Scayt,Replace,Form,Checkbox,Textarea,Select,Button,HiddenField,CreateDiv,BidiLtr,BidiRtl,Language,Flash,Smiley,SpecialChar,PageBreak,Iframe,Anchor,ShowBlocks,About,CopyFormatting,Undo,Redo",
                         
                            }}
                          onChange={onChange}
                        />
                        
                      </FormItem>
                    </div>
                  </div>

                  <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-24">
                      <div className="ant-row hd-title gx-m-0">
                        <div className="ant-col-md-12">
                          <h1>Thumbnail Image</h1>
                        </div>
                      </div>
                      <div className="ant-row gx-mt-4">
                        <div className="ant-col-md-24">
                          <div className="item-detail-edit-box">
                            <div className="ant-row">
                              <div className="ant-col-md-4 upload-img-main">
                                <Upload
                                  listType="picture-card"
                                  fileList={fileList}
                                  onPreview={handlePreview}
                                  customRequest={customRequest}
                                  onChange={handleChange}
                                  onRemove={handleRemove}
                                  accept="image/jpeg, image/png"
                                >
                                  {fileList?.length ? null : uploadButton}
                                </Upload>
                                <Modal
                                  visible={previewVisible}
                                  footer={null}
                                  onCancel={handleCancel}
                                >
                                  <img
                                    alt=""
                                    style={{ width: "100%" }}
                                    src={previewImage}
                                  />
                                </Modal>
                              </div>
                              <div className="ant-col-md-4">
                                <FormItem
                                  {...formItemLayout}
                                  labelAlign="left"
                                  label={<span><span style={{ color: "red" }}>*</span>Alt Text</span>}
                                >
                                  <Input
                                    type="text"
                                    placeholder="Alt Text"
                                    value={alt}
                                    onChange={handleAlt}
                                  />
                                </FormItem>
                              </div>
                              <div className="ant-col-md-8">
                                <FormItem
                                  {...formItemLayout}
                                  labelAlign="left"
                                  label={<span><span style={{ color: "red" }}>*</span>Caption</span>}
                                >
                                  <Input
                                    type="text"
                                    placeholder="Caption"
                                    value={caption}
                                    onChange={handleCaption}
                                  />
                                </FormItem>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </Card>
          <div className="ant-row gx-m-0 btn-right">
            <div className="ant-row gx-m-0 btn-left">
              <Button
                type="danger"
                className="color-white"
                onClick={history.goBack}
              >
                Back
                </Button>
            </div>

            <Button
              type="primary"
              className="color-white"
              onClick={onPreview}
              disabled={!isSave}
            >
              Preview
              </Button>
            {
              !isSave && <span style={{ color: "red" }}>*Preview not available</span>
            }

            <Button
              type="primary"
              className="color-white"
              onClick={onSubmit}
            >
              Save
              </Button>
          </div>
        </div>
      </div>
    </Spin>
  );
}

export default BlogForm;